var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-773e8688"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "py-4 hidden lg:block bg-white" };
var _hoisted_2 = { class: "flex justify-between items-center px-16" };
var _hoisted_3 = {
    key: 0,
    class: "w-72"
};
var _hoisted_4 = {
    class: "inline-block mt-1 text-primary hover:underline",
    href: "https://skillspace.ru",
    target: "_blank"
};
var _hoisted_5 = {
    key: 0,
    class: "text-primary",
    fill: "none",
    height: "45",
    width: "180",
    xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M9.437 16.463c1.811 0 3.254.747 4.328 2.241l3.683-3.292a7.142 7.142 0 0 0-3.5-2.584 13.2 13.2 0 0 0-4.373-.755c-1.104 0-2.194.137-3.268.412-1.074.274-2.026.701-2.854 1.28a6.647 6.647 0 0 0-2.003 2.218c-.506.9-.76 1.959-.76 3.178 0 .599.054 1.142.16 1.63a51.974 51.974 0 0 1 6.24-.532c-.584-.305-.875-.793-.875-1.463 0-.823.353-1.418 1.059-1.784a4.652 4.652 0 0 1 2.163-.549Zm-2.785 8.804a11.51 11.51 0 0 1-1.934-.548 52.535 52.535 0 0 1 12.354-.282c.065.085.13.17.192.258.582.823.874 1.951.874 3.384 0 1.311-.284 2.416-.852 3.316a6.665 6.665 0 0 1-2.21 2.172c-.905.549-1.925.945-3.06 1.19a16.187 16.187 0 0 1-3.407.365c-1.719 0-3.3-.244-4.742-.732-1.442-.487-2.731-1.372-3.867-2.652l3.683-3.43c.706.793 1.465 1.44 2.279 1.944.813.503 1.803.754 2.969.754.399 0 .813-.046 1.243-.137.43-.091.829-.244 1.197-.457.368-.214.667-.48.897-.8.23-.32.346-.694.346-1.121 0-.762-.292-1.326-.875-1.692-.583-.366-1.32-.663-2.21-.892a48.49 48.49 0 0 0-2.877-.64Zm13.466 9.306V24.82a49.95 49.95 0 0 1 5.524 1.185v8.568h-5.524Zm14.409 0-6.036-7.69c4.58 1.567 8.747 3.77 12.331 6.473l1.024 1.217h-7.32Zm-2.762-11.982 6.367 7.568c-4.953-3.982-11.121-6.976-18.014-8.584V0h5.524v21.723l8.516-9.101h7.09l-9.483 9.97Zm16.389-9.969h-5.525v21.951h5.525V12.622Zm-5.318-9.764c-.66.656-.99 1.426-.99 2.31 0 .884.33 1.654.99 2.31.66.655 1.497.982 2.51.982 1.012 0 1.864-.312 2.554-.937.69-.625 1.036-1.41 1.036-2.355 0-.945-.345-1.73-1.036-2.356-.69-.624-1.542-.937-2.555-.937-1.012 0-1.849.328-2.509.983ZM57.821 0h-5.524v34.573h5.524V0Zm9.713 0H62.01v34.573h5.524V0Zm11.51 16.463c1.81 0 3.253.747 4.327 2.241l3.683-3.292a7.141 7.141 0 0 0-3.5-2.584 13.199 13.199 0 0 0-4.372-.755c-1.105 0-2.195.137-3.269.412-1.074.274-2.025.701-2.854 1.28a6.646 6.646 0 0 0-2.003 2.218c-.506.9-.76 1.959-.76 3.178 0 1.403.292 2.5.875 3.293a6.036 6.036 0 0 0 2.21 1.852c.89.442 1.85.763 2.877.96 1.028.199 1.988.412 2.878.641.89.229 1.626.526 2.21.892.582.366.874.93.874 1.692 0 .427-.115.8-.345 1.12-.23.32-.53.587-.898.8a4.049 4.049 0 0 1-1.197.458c-.43.091-.844.137-1.243.137-1.166 0-2.156-.251-2.97-.755a10.356 10.356 0 0 1-2.278-1.943l-3.683 3.43c1.136 1.28 2.425 2.165 3.867 2.652 1.443.488 3.023.732 4.742.732 1.135 0 2.27-.122 3.406-.366 1.136-.244 2.157-.64 3.062-1.189a6.664 6.664 0 0 0 2.21-2.172c.567-.9.851-2.005.851-3.316 0-1.433-.291-2.56-.874-3.384a6.285 6.285 0 0 0-2.21-1.944c-.89-.472-1.85-.823-2.877-1.051-1.029-.229-1.987-.45-2.878-.663-.89-.214-1.626-.473-2.21-.778-.582-.305-.874-.793-.874-1.463 0-.823.353-1.418 1.059-1.784a4.652 4.652 0 0 1 2.163-.549Zm15.928-3.841h-5.248V29.08a40.745 40.745 0 0 1 5.536-3.81 7.137 7.137 0 0 1-.196-1.673c0-.854.146-1.677.437-2.47a6.19 6.19 0 0 1 1.29-2.104 6.419 6.419 0 0 1 2.048-1.463c.798-.366 1.703-.549 2.716-.549 1.013 0 1.918.183 2.716.549a6.424 6.424 0 0 1 2.049 1.463c.417.449.76.946 1.028 1.493a48.547 48.547 0 0 1 5.635-.992 13.914 13.914 0 0 0-.149-.455c-.491-1.402-1.213-2.622-2.164-3.658-.951-1.037-2.102-1.853-3.453-2.447-1.35-.595-2.869-.892-4.557-.892-1.565 0-3.023.305-4.374.915-1.35.61-2.424 1.585-3.222 2.927h-.092v-3.293Zm35.263 7.902c1.706.407 3.365.902 4.972 1.48v-.053c0-.518-.015-1.12-.046-1.806-.03-.686-.13-1.395-.3-2.127a8.726 8.726 0 0 0-.828-2.172c-.384-.716-.928-1.349-1.634-1.898-.706-.549-1.596-.998-2.67-1.349-1.074-.35-2.394-.526-3.959-.526-1.75 0-3.445.275-5.087.823a10.713 10.713 0 0 0-4.304 2.698l2.9 2.882a8.272 8.272 0 0 1 2.624-1.67 8.597 8.597 0 0 1 3.268-.617c1.474 0 2.686.343 3.637 1.029.952.686 1.427 1.715 1.427 3.087v.22Zm4.972 4.31a49.183 49.183 0 0 0-12.841-1.684c-1.713 0-3.401.086-5.059.254a6.262 6.262 0 0 0-1.711 2.091c-.43.839-.645 1.853-.645 3.042 0 1.097.231 2.058.691 2.88a6.35 6.35 0 0 0 1.818 2.059c.752.548 1.612.96 2.578 1.234.967.275 1.957.412 2.97.412 1.473 0 2.823-.282 4.051-.846 1.227-.564 2.24-1.471 3.038-2.721h.138v3.018h4.972v-9.739Zm-21.64-.907c-1.966.353-3.88.822-5.73 1.398-.062.25-.138.498-.228.742a6.211 6.211 0 0 1-1.289 2.104 6.423 6.423 0 0 1-2.049 1.463c-.798.366-1.703.549-2.716.549-1.013 0-1.918-.183-2.716-.549a7.03 7.03 0 0 1-.371-.183c-3.31 1.947-6.258 4.288-8.744 6.94V45h5.524V31.784h.138c.276.366.63.739 1.06 1.12.429.381.95.74 1.564 1.075.614.335 1.32.61 2.118.823.798.213 1.719.32 2.762.32 1.565 0 3.008-.297 4.327-.892a10.076 10.076 0 0 0 3.384-2.446c.936-1.037 1.665-2.257 2.187-3.659.486-1.307.745-2.706.779-4.198Zm24.33 1.722c5.896 1.982 11.115 5.059 15.284 8.926-.578.172-1.137.302-1.677.387a11.44 11.44 0 0 1-1.749.16c-1.658 0-3.223-.274-4.696-.823-1.474-.549-2.747-1.326-3.822-2.333-1.073-1.006-1.925-2.218-2.554-3.635a10.777 10.777 0 0 1-.786-2.682Zm15.358 8.904a13.017 13.017 0 0 0 2.553-1.077 8.5 8.5 0 0 0 1.911-1.418l-3.683-3.933a5.193 5.193 0 0 1-1.888 1.532 5.497 5.497 0 0 1-2.393.526c-.23 0-.452-.01-.67-.028a36.19 36.19 0 0 1 4.17 4.398Zm-9.531-8.423a43.305 43.305 0 0 0-5.972-3.125c.064-1.506.375-2.886.931-4.14.629-1.418 1.481-2.63 2.554-3.636 1.075-1.006 2.348-1.784 3.822-2.333 1.473-.548 3.038-.823 4.696-.823 1.412 0 2.83.267 4.258.8 1.427.534 2.678 1.38 3.752 2.539l-3.821 3.795c-.645-.67-1.32-1.204-2.025-1.6-.707-.397-1.428-.595-2.164-.595-1.014 0-1.919.183-2.716.549a6.417 6.417 0 0 0-2.05 1.463 6.176 6.176 0 0 0-1.288 2.104 7.088 7.088 0 0 0-.437 2.47 7.086 7.086 0 0 0 .46 2.532Zm-14.962-1.39h1.151v1.236c0 1.555-.453 2.782-1.358 3.681-.905.9-2.309 1.35-4.212 1.35-.461 0-.921-.054-1.381-.161a3.762 3.762 0 0 1-1.243-.526 3.105 3.105 0 0 1-.898-.892c-.23-.35-.345-.785-.345-1.303 0-.793.291-1.41.874-1.852.583-.442 1.297-.778 2.141-1.006a13.619 13.619 0 0 1 2.693-.435 40.66 40.66 0 0 1 2.578-.091Zm34.389.778c.184 1.647.829 2.927 1.933 3.842 1.105.914 2.44 1.372 4.005 1.372 1.382 0 2.54-.282 3.476-.846a9.604 9.604 0 0 0 2.463-2.127l3.959 2.973c-1.288 1.585-2.731 2.713-4.327 3.384a12.824 12.824 0 0 1-5.019 1.006c-1.657 0-3.221-.274-4.694-.823-1.474-.549-2.747-1.326-3.822-2.333-1.074-1.006-1.925-2.218-2.554-3.635-.63-1.418-.944-2.996-.944-4.733 0-1.738.314-3.316.944-4.734.629-1.417 1.48-2.63 2.554-3.635 1.075-1.006 2.348-1.784 3.822-2.333a13.334 13.334 0 0 1 4.694-.823c1.535 0 2.939.267 4.214.8a9.043 9.043 0 0 1 3.268 2.31c.905 1.006 1.612 2.248 2.117 3.727.507 1.479.76 3.178.76 5.1v1.508h-16.849Zm11.325-4.116c-.031-1.615-.537-2.888-1.52-3.818-.981-.93-2.347-1.395-4.096-1.395-1.657 0-2.969.473-3.937 1.418-.967.945-1.558 2.21-1.772 3.795h11.325Z",
    fill: "currentColor",
    "fill-rule": "evenodd"
}, null, -1); });
var _hoisted_7 = [
    _hoisted_6
];
var _hoisted_8 = ["alt", "src"];
var _hoisted_9 = { class: "flex items-center gap-10" };
var _hoisted_10 = {
    key: 0,
    class: "flex items-stretch"
};
var _hoisted_11 = {
    key: 2,
    class: "flex items-stretch mr-10"
};
var _hoisted_12 = {
    key: 3,
    class: "flex items-schrink"
};
var _hoisted_13 = { key: 4 };
import EAvatar from '@common/ui/EAvatar/EAvatar.vue';
import ELink from '@common/ui/ELink.vue';
import Auth from '@common/modules/auth';
import { AuthModalStore, CoreStore } from '@student/modules/store';
import ETooltip from '@common/ui/ETooltip.vue';
import EButton from '@common/ui/EButton.vue';
import EIcon from '@common/ui/EIcon.vue';
import { computed, ref, watch } from 'vue';
import EDropdown from '@common/ui/EDropdown/EDropdown.vue';
import UserInfo from '@student/components/UserInfo.vue';
import EMenu from '@common/ui/EMenu/EMenu.vue';
import NotificationsPanel from '@common/components/Notifications/NotificationsPanel.vue';
import { GetAllNotificationsDocument, useGetAllNotificationsQuery } from '@common/graphql/operations';
import { useNotificationSocket } from '@common/api/ws/hooks/useNotificationWebsocket';
import client from '../../../apolloClient';
import NotificationsSocketPanel from '@common/components/Notifications/NotificationsSocketPanel.vue';
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseNav',
    setup: function (__props) {
        var isProfileOpen = ref(false);
        var isNotificationsOpen = ref(false);
        var t = useI18n().t;
        var auth = computed(function () { return Auth; });
        var user = computed(function () { return CoreStore.user; });
        var school = computed(function () { return CoreStore.school; });
        var whiteLabelHideLogo = computed(function () { return CoreStore.schoolSettings.whiteLabelHideLogo; });
        var isGuest = computed(function () { return Auth.isGuest(); });
        var userId = computed(function () { return CoreStore.user.id; });
        var _a = useGetAllNotificationsQuery(function () { return ({
            pagination: {
                skip: 0,
                take: 20,
            }
        }); }, {
            enabled: !isGuest.value
        }), notifications = _a.result, refetch = _a.refetch;
        var isHasNewNotifications = computed(function () { var _a; return !!((_a = notifications.value) === null || _a === void 0 ? void 0 : _a.notificationsCount.find(function (item) { return item.countUnread > 0; })); });
        watch(userId, function (newId, oldId) {
            if (!newId)
                return;
            if (newId !== oldId) {
                refetch();
            }
        }, { immediate: true });
        var login = function () { return AuthModalStore.showLogin(); };
        var register = function () { return AuthModalStore.showRegister(); };
        useNotificationSocket(function (payload) {
            client.cache.updateQuery({
                query: GetAllNotificationsDocument,
                variables: {
                    pagination: {
                        skip: 0,
                        take: 20
                    }
                }
            }, function (data) {
                var _a;
                var newNotificationCount = data === null || data === void 0 ? void 0 : data.notificationsCount.map(function (item) { return item.type === payload.type ? __assign(__assign({}, item), { countUnread: item.countUnread + 1 }) : item; });
                return {
                    notifications: __spreadArray([payload], __read(((_a = data === null || data === void 0 ? void 0 : data.notifications) !== null && _a !== void 0 ? _a : [])), false),
                    notificationsCount: __spreadArray([], __read((newNotificationCount !== null && newNotificationCount !== void 0 ? newNotificationCount : [])), false)
                };
            });
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(ETooltip, {
                        disabled: whiteLabelHideLogo.value,
                        trigger: "hover"
                    }, {
                        tooltip: _withCtx(function () { return [
                            (!whiteLabelHideLogo.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('header.platformDescription')), 1),
                                    _createElementVNode("a", _hoisted_4, _toDisplayString(_unref(t)('header.learnMore')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ]; }),
                        default: _withCtx(function () { return [
                            _createVNode(ELink, {
                                "href-to": { name: 'schoolCatalog' },
                                class: "logo"
                            }, {
                                default: _withCtx(function () { return [
                                    (!whiteLabelHideLogo.value)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
                                        : (!!school.value.logo)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 1,
                                                alt: school.value.name,
                                                src: school.value.logo
                                            }, null, 8, _hoisted_8))
                                            : _createCommentVNode("", true)
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    }, 8, ["disabled"]),
                    _createElementVNode("div", _hoisted_9, [
                        (!whiteLabelHideLogo.value && _ctx.$route.name !== 'WebinarTranslation')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                (user.value.id)
                                    ? (_openBlock(), _createBlock(ELink, {
                                        key: 0,
                                        "href-to": { name: 'profilePartner' },
                                        class: "hidden lg:inline-flex font-medium ml-4 items-center px-3 py-1.5 text-gray-500 hover:bg-dark-100 rounded-lg transition-colors"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(EIcon, {
                                                class: "w-5 h-5 text-primary mr-2",
                                                icon: "dollar-round"
                                            }),
                                            _createTextVNode(" " + _toDisplayString(_unref(t)('header.partnerProgram')), 1)
                                        ]; }),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _renderSlot(_ctx.$slots, "timer"),
                        (!isNotificationsOpen.value)
                            ? (_openBlock(), _createBlock(NotificationsSocketPanel, { key: 1 }))
                            : _createCommentVNode("", true),
                        (!auth.value.isGuest())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(EDropdown, {
                                    visible: isNotificationsOpen.value,
                                    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) { return ((isNotificationsOpen).value = $event); }),
                                    "allowed-placements": ['bottom-end'],
                                    trigger: "click",
                                    fullwidth: ""
                                }, {
                                    overlay: _withCtx(function () { return [
                                        _createVNode(EMenu, null, {
                                            default: _withCtx(function () { return [
                                                _createVNode(NotificationsPanel)
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    default: _withCtx(function () { return [
                                        _createElementVNode("div", {
                                            class: _normalizeClass([[isNotificationsOpen.value && 'bg-gray-200 text-dark/80'], "rounded-lg cursor-pointer hover:bg-gray-200 flex justify-center items-center w-10 h-10 text-dark/40"])
                                        }, [
                                            (isHasNewNotifications.value)
                                                ? (_openBlock(), _createBlock(EIcon, {
                                                    key: 0,
                                                    class: "new-notifications-icon w-5 h-5",
                                                    icon: "bicolor/bell-with-circle"
                                                }))
                                                : (_openBlock(), _createBlock(EIcon, {
                                                    key: 1,
                                                    class: "w-5 h-5",
                                                    icon: "notifications/notification"
                                                }))
                                        ], 2)
                                    ]; }),
                                    _: 1
                                }, 8, ["visible"])
                            ]))
                            : _createCommentVNode("", true),
                        (!auth.value.isGuest())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(EDropdown, {
                                    visible: isProfileOpen.value,
                                    "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) { return ((isProfileOpen).value = $event); }),
                                    "allowed-placements": ['bottom-end'],
                                    trigger: "click",
                                    fullwidth: ""
                                }, {
                                    overlay: _withCtx(function () { return [
                                        _createVNode(UserInfo)
                                    ]; }),
                                    default: _withCtx(function () { return [
                                        _createElementVNode("div", {
                                            class: _normalizeClass([[isProfileOpen.value && 'text-dark/80 hover:text-dark/80'], "flex items-center cursor-pointer text-dark/20 hover:text-dark/40 group"])
                                        }, [
                                            _createVNode(EAvatar, {
                                                class: _normalizeClass([[
                                                        isProfileOpen.value && user.value.avatar && '!border-dark/30',
                                                        user.value.avatar && 'group-hover:border-dark/30'
                                                    ], "user-avatar"]),
                                                "color-id": user.value.id,
                                                name: user.value.name || user.value.email,
                                                primary: false,
                                                src: user.value.avatar
                                            }, null, 8, ["class", "color-id", "name", "src"]),
                                            _createVNode(EIcon, {
                                                class: "ml-2.5 w-2 h-1.5",
                                                icon: "triangle-arrow-down"
                                            })
                                        ], 2)
                                    ]; }),
                                    _: 1
                                }, 8, ["visible"])
                            ]))
                            : _createCommentVNode("", true),
                        (auth.value.isGuest())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(EButton, {
                                    type: "secondary",
                                    onClick: login
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(EIcon, {
                                            class: "w-5 h-5 mr-2",
                                            icon: "log-in"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(t)('header.login')), 1)
                                    ]; }),
                                    _: 1
                                }),
                                (school.value.allowSelfRegister)
                                    ? (_openBlock(), _createBlock(EButton, {
                                        key: 0,
                                        class: "ml-2",
                                        type: "primary-alt",
                                        onClick: register
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createTextVNode(_toDisplayString(_unref(t)('header.register')), 1)
                                        ]; }),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
